/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RestrictionCheckSearchRequestDTOOutcomesEnum = {
    Unrestricted: 'UNRESTRICTED',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    NotEligible: 'NOT_ELIGIBLE',
    NotFound: 'NOT_FOUND',
    Error: 'ERROR'
};
/**
 * Check if a given object implements the RestrictionCheckSearchRequestDTO interface.
 */
export function instanceOfRestrictionCheckSearchRequestDTO(value) {
    return true;
}
export function RestrictionCheckSearchRequestDTOFromJSON(json) {
    return RestrictionCheckSearchRequestDTOFromJSONTyped(json, false);
}
export function RestrictionCheckSearchRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'outcomes': json['outcomes'] == null ? undefined : json['outcomes'],
    };
}
export function RestrictionCheckSearchRequestDTOToJSON(json) {
    return RestrictionCheckSearchRequestDTOToJSONTyped(json, false);
}
export function RestrictionCheckSearchRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'outcomes': value['outcomes'],
    };
}
